// extracted by mini-css-extract-plugin
export var activityContainer = "_mz-0";
export var typingIndicatorContainer = "_mz-1";
export var typingIndicatorDot = "_mz-2";
export var wave = "_mz-3";